import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'Footer',
    templateUrl: './footer.component.html'
})

export class FooterComponent {
    currentYear: number;

    constructor() {
        this.currentYear = moment().year();
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/footer/footer.component.ts